import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "login-view-container" }
const _hoisted_2 = { class: "login-box-container d-flex justify-center align-center" }
const _hoisted_3 = { class: "mx-12 my-10" }
const _hoisted_4 = {
  key: 0,
  class: "text-h5 mb-8 font-weight-bold"
}
const _hoisted_5 = {
  key: 1,
  class: "text-h5 mb-8 font-weight-bold"
}
const _hoisted_6 = { class: "d-flex justify-end mt-3 mr-2" }
const _hoisted_7 = {
  key: 1,
  class: "mx-2 login-box-divider"
}

import PasswordLogin from "@/components/login/PasswordLogin.vue";
import {ref} from "vue";
import CaptchaLogin from "@/components/login/CaptchaLogin.vue";
import RegisterBox from "@/components/login/RegisterBox.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const captchaMode = ref<boolean>(false)
const registerMode = ref<boolean>(false)

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "login-header" }, "数字化智能教学互动平台", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_sheet, {
        width: 500,
        class: "login-box rounded-xl"
      }, {
        default: _withCtx(() => [
          (registerMode.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "h-0 ml-6 mt-4 text-lg return-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (registerMode.value = false))
              }, [
                _createVNode(_component_v_icon, {
                  class: "mb-1",
                  icon: "mdi-chevron-left"
                }),
                _cache[4] || (_cache[4] = _createTextVNode(_toDisplayString(' 返回')))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            (!registerMode.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "教师登录"))
              : _createCommentVNode("", true),
            (registerMode.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "新用户注册"))
              : _createCommentVNode("", true),
            (registerMode.value)
              ? (_openBlock(), _createBlock(RegisterBox, {
                  key: 2,
                  onPushBack: _cache[1] || (_cache[1] = ($event: any) => (registerMode.value = false))
                }))
              : _createCommentVNode("", true),
            (!registerMode.value && captchaMode.value)
              ? (_openBlock(), _createBlock(CaptchaLogin, { key: 3 }))
              : _createCommentVNode("", true),
            (!registerMode.value && !captchaMode.value)
              ? (_openBlock(), _createBlock(PasswordLogin, { key: 4 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              (!registerMode.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "text-caption text-decoration-none text-blue",
                    href: "#",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (registerMode.value = true))
                  }, "新用户注册"))
                : _createCommentVNode("", true),
              (!registerMode.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "|"))
                : _createCommentVNode("", true),
              (!registerMode.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    class: "text-caption text-decoration-none text-blue",
                    href: "#",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (captchaMode.value = !captchaMode.value))
                  }, _toDisplayString(captchaMode.value ? '邮箱密码登录' : '验证码登录'), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "login-footer d-flex justify-center align-center" }, [
      _createElementVNode("div", null, "Copyright © 2025 西南石油大学")
    ], -1))
  ]))
}
}

})